import {CaretPosition, EditorFrameObjects, RootContainerFrameDefinition, ImportsContainerDefinition, FuncDefContainerDefinition, MainFramesContainerDefinition, getFrameDefType, AllFrameTypesIdentifier} from "@/types/types";

const longStateExample: EditorFrameObjects = {
    0: {
        id: 0,
        frameType : RootContainerFrameDefinition,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [-1, -2, -3],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: { },
        caretVisibility: CaretPosition.none,
    },
    "-1": {
        id: -1,
        frameType : ImportsContainerDefinition,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [1,2],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {},
        isCollapsed: false,
        caretVisibility: CaretPosition.none,
    },
    "-2": {
        id: -2,
        frameType : FuncDefContainerDefinition,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: { },
        isCollapsed: false,
        caretVisibility: CaretPosition.none,
    },
    "-3": {
        id: -3,
        frameType : MainFramesContainerDefinition,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 0,
        childrenIds: [3,4,5,6,7,8],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {},
        isCollapsed: false,
        caretVisibility: CaretPosition.body,
    },

    1: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.fromimport),
        id: 1,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -1,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: { 
            0: {slotStructures: {operators: [], fields: [{code: "microbit"}]}},
            1: {slotStructures: {operators: [], fields: [{code: "*"}]}},
            2: {slotStructures: {operators: [], fields: [{code: ""}]}, shown: false}},
        caretVisibility: CaretPosition.none,
    },
    2: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.import),
        id: 2,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -1,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [], fields: [{code: "music"}]}}},
        caretVisibility: CaretPosition.none,
    },
    3: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.comment),
        id: 3,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [], fields: [{code: "At start:"}]}}},
        caretVisibility: CaretPosition.none,
    },
    4: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 4,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "."}, {code: ""}, {code: ""}], fields: [{code: "music"}, {openingBracketValue: "(", fields: [{code:"music"}, {code: "NYAN"}], operators: [{code: "."}]}, {code :""}]}}},
        caretVisibility: CaretPosition.none,
    },
    5: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 5,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "."}, {code: ""}, {code: ""}], fields: [{code: "display"}, {code: "scroll"}, {openingBracketValue: "(", fields: [{code: ""}, {code: "I love Stride micro:bit !", quote:"\""}, {code: ""}], operators: [{code: ""}, {code: ""}]}, {code : ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    6: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.comment),
        id: 6,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [], fields: [{code: "Maintain this behaviour while on:"}]}}},
        caretVisibility: CaretPosition.none,
    },
    7: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.varassign),
        id: 7,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {
            0: {slotStructures: {operators: [], fields: [{code: "currImg"}]}},
            1: {slotStructures: {operators: [{code: "."}], fields: [{code: "Image"}, {code: "HEART"}]}}},
        caretVisibility: CaretPosition.none,
    },
    8: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.while),
        id: 8,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: -3,
        childrenIds: [9,10,11,12,13],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [], fields: [{code: "True"}]}}},
        caretVisibility: CaretPosition.none,
    },
    9: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 9,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 8,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: { 
            0: {slotStructures: {operators: [{code: "."}, {code: ""}, {code : ""}], fields: [{code: "display"}, {code: "show"}, {openingBracketValue:"(", fields: [{code: "currImg"}], operators:[]}, {code : ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    10: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.varassign),
        id: 10,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 8,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {
            0: {slotStructures: {operators: [], fields: [{code: "gesture"}]}},
            1: {slotStructures: {operators:[{code: "."},  {code: ""}, {code : ""}], fields:[{code: "accelerometer"}, {code: "current_gesture"}, {openingBracketValue: "(", fields: [{code: ""}], operators: []}, {code : ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    11: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.if),
        id: 11,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 8,
        childrenIds: [14,15],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: { 0: {slotStructures: {operators: [{code: "=="}, {code: ""}, {code: ""}], fields: [{code: "gesture"}, {code: ""}, {code: "shake", quote: "\""}, {code: ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    14: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 14,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 11,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "."}, {code: ""}, {code : ""}], fields: [{code: "display"}, {code: "show"}, {openingBracketValue:"(", fields: [{code: "Image"}, {code: "SAD"}], operators:[{code: "."}]}, {code : ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    15: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.funccall),
        id: 15,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 11,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: ""}, {code : ""}], fields: [{code: "sleep"}, {openingBracketValue: "(", fields:[{code: "2000"}], operators: []}, {code : ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    12: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.if),
        id: 12,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 8,
        childrenIds: [16],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "."}, {code: ""}, {code : ""}], fields: [{code: "button_a"}, {code: "is_pressed"}, {openingBracketValue:"(", fields: [{code: ""}], operators:[]}, {code : ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    16: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.varassign),
        id: 16,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 12,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {
            0: {slotStructures: {operators: [], fields: [{code: "currImg"}]}},
            1: {slotStructures: {operators: [{code: "."}], fields: [{code: "Image"}, {code: "CHESSBOARD"}]}}},
        caretVisibility: CaretPosition.none,
    },
    13: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.if),
        id: 13,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 8,
        childrenIds: [17],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {0: {slotStructures: {operators: [{code: "."}, {code: ""}, {code : ""}], fields: [{code: "button_b"}, {code: "is_pressed"}, {openingBracketValue:"(", fields: [{code: ""}], operators:[]}, {code : ""}]}}},
        caretVisibility: CaretPosition.none,
    },
    17: {
        frameType: getFrameDefType(AllFrameTypesIdentifier.varassign),
        id: 17,
        isDisabled: false,
        isSelected: false,
        isVisible: true,
        parentId: 13,
        childrenIds: [],
        jointParentId: 0,
        jointFrameIds: [],
        labelSlotsDict: {
            0: {slotStructures: {operators: [], fields: [{code: "currImg"}]}},
            1: {slotStructures: {operators: [{code: "."}], fields: [{code: "Image"}, {code: "COW"}]}}},
        caretVisibility: CaretPosition.none,
    },
};

export default longStateExample;


